import React from 'react';
import { FileTextIcon, DownloadIcon } from 'lucide-react';
interface Document {
  title: string;
  url: string;
}
interface DocumentListProps {
  documents: Document[];
}
const DocumentList: React.FC<DocumentListProps> = ({
  documents
}) => {
  return <div className="bg-white rounded-lg shadow-md p-6" data-id="element-63">
      <h3 className="text-xl font-semibold text-gray-900 mb-4" data-id="element-64">
        Property Documents
      </h3>
      {documents.length === 0 ? <p className="text-gray-600" data-id="element-65">No documents available</p> : <ul className="divide-y divide-gray-200" data-id="element-66">
          {documents.map((doc, index) => <li key={index} className="py-3 first:pt-0 last:pb-0" data-id="element-67">
              <a href={doc.url} className="flex items-center justify-between hover:bg-gray-50 p-2 rounded-md transition" data-id="element-68">
                <div className="flex items-center" data-id="element-69">
                  <FileTextIcon className="h-5 w-5 text-blue-600 mr-3" data-id="element-70" />
                  <span className="text-gray-800" data-id="element-71">{doc.title}</span>
                </div>
                <DownloadIcon className="h-5 w-5 text-gray-600" data-id="element-72" />
              </a>
            </li>)}
        </ul>}
    </div>;
};
export default DocumentList;